<template>
  <div>
    <b-row>
      <b-col>
        <search-box v-model="query" />
      </b-col>
      <b-col class="text-right">
        <span class="mr-2">{{ activeInactiveStores }}</span>
        <!-- <b-button
          size="sm"
          variant="outline-primary"
          class="mr-2"
          @click="downloadStores()"
        >
          Download CSV
        </b-button> -->
        <b-button
          size="sm"
          variant="outline-success"
          class="mr-2"
          :disabled="!stores || !stores.length || storeFileLoading"
          @click="downloadStores()"
        >
          <span>{{ storeFileLoading ? getLabel('FILE_GENERATING') : getLabel('DOWNLOAD_EXCEL') }}</span>
        </b-button>
        <b-button
          v-if="
            auth.user.selectedAccess.roleLevel > 0 &&
            auth.user.selectedAccess.can_modify_settings
          "
          v-router-link="addStore"
          size="sm"
          variant="outline-primary"
        >
          <span v-label-key="'ADD_STORE'">Add Store</span>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-table
          id="store-table"
          ref="storeTable"
          :per-page="0"
          :current-page="currentPage"
          :items="stores"
          :fields="fields"
          :busy="loading"
          show-empty
          striped
          hover
          responsive
          @sort-changed="handleSortChange"
        >
          <template v-slot:cell(name)="data">
            <router-link :to="{ name: 'store-detail', params: data.item }">
              {{ data.item.name }}
            </router-link>
          </template>
          <template v-slot:cell(distributor_name)="data">
            <router-link
              v-if="auth.user.selectedAccess.roleLevel > 2"
              :to="{
                name: 'distributor-detail',
                params: { id: data.item.distributor_id },
              }"
            >
              {{ data.item.distributor_name }}
            </router-link>
            <span v-if="auth.user.selectedAccess.roleLevel <= 2">{{
              data.item.distributor_name
            }}</span>
          </template>
          <template v-slot:cell(subdistributor_name)="data">
            <router-link
              v-if="
                auth.user.selectedAccess.roleLevel > 1 &&
                data.item.subdistributor_id
              "
              :to="{
                name: 'subdistributor-detail',
                params: { id: data.item.subdistributor_id },
              }"
            >
              {{ data.item.subdistributor_name }}
            </router-link>
            <span v-if="auth.user.selectedAccess.roleLevel <= 1">{{
              data.item.subdistributor_name
            }}</span>
          </template>
          <template v-slot:cell(chain_name)="data">
            <router-link
              v-if="auth.user.selectedAccess.roleLevel > 0"
              :to="{ name: 'chain-detail', params: { id: data.item.chain_id } }"
            >
              {{ data.item.chain_name }}
            </router-link>
            <span v-if="auth.user.selectedAccess.roleLevel <= 0">{{
              data.item.chain_name
            }}</span>
          </template>
          <template v-slot:cell(created)="data">
            {{ data.item.created | moment("YYYY-MM-DD") }}
          </template>
          <template v-slot:cell(transactioncount)="data">
            {{ data.item.transactioncount || 0 }}
          </template>
          <template v-slot:cell(successcount)="data">
            {{ data.item.successcount || 0 }}
          </template>
          <template v-slot:cell(confirmedcount)="data">
            {{ data.item.confirmedcount || 0 }}
          </template>
          <template v-slot:cell(failedcount)="data">
            {{ data.item.failedcount || 0 }}
          </template>
          <template v-slot:cell(active)="data">
            {{
              data.item.active == 1
                ? getLabel("STORE_ACTIVE")
                : getLabel("STORE_INACTIVE")
            }}
          </template>
          <template v-slot:cell(fspacks_registered)="data">
            {{ fsFilmAndPackCount(data.item.fspacks_registered) }}
          </template>
          <template v-slot:table-busy>
            <loading-spinner />
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="total"
          :per-page="perPage"
          align="right"
          aria-controls="store-table"
          @change="pageChanged"
        />
      </b-col>
      <b-col md="3">
        <b-card no-body>
          <b-card-header>
            <span v-label-key="'SHOW_CUTS_FROM_DATE_RANGE'"
              >Show Cuts From</span
            >
          </b-card-header>
          <b-card-body>
            <date-range-selector @input="loadStores" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import debounce from "lodash.debounce";
// import $csv from '@/services/csv';
import $excel from "@/services/excel";
import $api from "@/services/api";
import $auth from "@/services/auth";
import LoadingSpinner from "@/components/LoadingSpinner";
import SearchBox from "@/components/SearchBox";
import DateRangeSelector from "@/components/DateRangeSelector";
import $search from "@/services/search";
import { mapGetters } from "vuex";

export default {
  name: "StoreList",

  components: {
    LoadingSpinner,
    SearchBox,
    DateRangeSelector,
  },

  props: [
    /* eslint-disable vue/prop-name-casing, vue/require-prop-types */
    "distributor_id",
    "subdistributor_id",
    "chain_id",
    "store_id",
  ],

  data() {
    return {
      auth: $auth,
      query: null,
      stores: [],
      storeStatusCount: null,
      dateRange: null,
      search: $search,
      perPage: 10,
      currentPage: 1,
      total: 0,
      orderBy: '',
      isOrderByDesc: false,
      loading: false,
      storeFileLoading: false,
    };
  },

  computed: {
    ...mapGetters("translations", {
      getLabel: "getLabel",
      getReplaceLabel: "getReplaceLabel",
    }),
    activeInactiveStores() {
      return this.getReplaceLabel("STORES_ACTIVE_INACTIVE", {
        "{ACTIVE_STORE_COUNT}": this.storeStatusCount?.active || 0,
        "{INACTIVE_STORE_COUNT}": this.storeStatusCount?.inactive || 0,
      });
    },
    fields() {
      const fields = [
        { key: "id", label: "ID", labelKey: "ID", sortable: true },
        {
          key: "name",
          label: "Name",
          labelKey: "NAME",
          sortable: true,
        },
        {
          key: "chain_group",
          label: "Chain Group",
          labelKey: "STORE_SETTING_SET_CHAIN_GROUP",
          sortable: true,
        },
        {
          key: "distributor_name",
          label: "Distributor",
          labelKey: "DISTRIBUTOR",
          sortable: true,
        },
        {
          key: "subdistributor_name",
          label: "Subdistributor",
          labelKey: "SUBDISTRIBUTOR",
          sortable: true,
        },
        {
          key: "chain_name",
          label: "Chain",
          labelKey: "CHAIN",
          sortable: true,
        },
        {
          key: "credits_available",
          label: "Credits",
          labelKey: "STORE_BYPASS_CREDITS",
          sortable: true,
        },
        {
          key: "created",
          label: "Created",
          labelKey: "CREATED",
          sortable: true,
        },
        {
          key: "transactioncount",
          label: "Cuts",
          labelKey: "CUTS",
          sortable: false,
        },
        {
          key: "successcount",
          label: "Success Cuts",
          labelKey: "CUT_STATUS_CUT_SUCCESS",
          sortable: false,
        },
        {
          key: "confirmedcount",
          label: "Confirmed Cuts",
          labelKey: "CUT_STATUS_CUT_CONFIRMED",
          sortable: false,
        },
        {
          key: "failedcount",
          label: "Failed Cuts",
          labelKey: "CUT_STATUS_CUT_FAILED",
          sortable: false,
        },
        { key: "active", label: "Status", labelKey: "STATUS", sortable: true },
        {
          key: "fspacks_registered",
          label: "Four Seasons Films Registered",
          labelKey: "FOUR_SEASONS_FILMS_REGISTERED",
        },
        {
          key: "fsfilms_available_new",
          label: "Four Seasons Films Remaining",
          labelKey: "FOUR_SEASONS_FILMS_REMAINING",
        },
      ];
      if (!this.showChainGroup) fields.splice(2, 1);
      fields.forEach((field) => {
        if (field.labelKey)
          field.label = this.getLabel(field.labelKey) || field.label;
      });
      return fields;
    },

    totalRows() {
      return (
        this.$store.state.global.stores &&
        this.search(this.$store.state.global.stores, this.query).length
      );
    },

    fsFilmAndPackCount() {
      return (packCount) => {
        return this.getReplaceLabel("STORE_FOUR_SEASON_PACK_FILM_COUNT", {
          "{FOUR_SEASON_FILM_COUNT}": (packCount || 0) * 4,
          "{FOUR_SEASON_PACK_COUNT}": packCount || 0,
        });
      };
    },

    addStore() {
      if (this.$route.name === "store-list") {
        return { name: "store-editor" };
      }

      return {
        name: "store-editor",
        query: {
          distributor_id: this.$store.state.global.params.distributor_id,
          subdistributor_id: this.$store.state.global.params.subdistributor_id,
          chain_id: this.$store.state.global.params.chain_id,
        },
      };
    },

    showChainGroup() {
      //return this.$store.state.global.stores.some((store) => store.chain_group);
      return this.stores.some((store) => store.chain_group);
    },

    downloadStoreList() {
      return this.$store.state.global.stores;
    },
  },
  watch: {
    query(newValue) {
      this.debounceSearch(newValue);
    },
  },
  beforeDestroy() {
    if (this.debounceSearch && this.debounceSearch.cancel) {
      this.debounceSearch.cancel();
    }
  },
  created() {
    this.debounceSearch = debounce(() => {
      this.currentPage = 1;
      this.refreshData();
    }, 500);
  },
  methods: {
    loadStores(range) {
      this.dateRange = range;
      this.refreshData();
    },
    pageChanged(page) {
      this.currentPage = page;
      this.refreshData();
    },
    handleSortChange(e){
      this.orderBy = e.sortBy;
      this.isOrderByDesc = e.sortDesc;
      this.refreshData();
    },
    refreshData() {
      this.loading = true;
      this.stores = [];

      let tempQuery = this.getListQuery();

      tempQuery += `&skip=${(this.currentPage - 1) * this.perPage}&take=${
        this.perPage
      }`;

      $api
        .get("/v1/dashboard/stores" + tempQuery)
        .then((response) => {
          this.stores = response.data;
          this.total = response.total;
          this.storeStatusCount = response.statusCount;
          this.$emit("loaded", response.data);
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
          this.$refs.storeTable.refresh();
        });
    },

    downloadStores() {
      this.storeFileLoading = true;

      const headerKeys = [
        "ID",
        "NAME",
        "STORE_SETTING_SET_CHAIN_GROUP",
        "DISTRIBUTOR_ID",
        "SUBDISTRIBUTOR_ID",
        "CHAIN_ID",
        "CHAIN_NAME",
        "LOCATION_STREET",
        "LOCATION_REGION",
        "LOCATION_COUNTRY",
        "LOCATION_POSTCODE",
        "NOTIFICATION_EMAIL",
        "OPENING_HOURS",
        "STORE_BYPASS_CREDITS",
        "CREATED",
        "TRANSACTIONS",
        "STORE_ACTIVE",
        "FOUR_SEASONS_PACKS_REGISTERED",
        "STORE_FOUR_SEASONS_FILMS_AVAILABLE",
      ];
      const headers = headerKeys.map(this.getLabel);
      const fields = [
        "id",
        "name",
        "chain_group",
        "distributor_id",
        "subdistributor_id",
        "chain_id",
        "chain_name",
        "street",
        "region",
        "country",
        "postcode",
        "notification_email",
        "opening_hours",
        "credits_available",
        "created",
        "transactioncount",
        "active",
        "fspacks_registered",
        "fsfilms_available",
      ];

      // Hide the chain group column if there is none to show for the stores
      if (!this.showChainGroup) fields.splice(fields.indexOf("chain_group"), 1);
      if (!this.showChainGroup) {
        headers.splice(headerKeys.indexOf("STORE_SETTING_SET_CHAIN_GROUP"), 1);
      }
      // $csv.export(this.downloadStoreList, fields, 'stores.csv');

      const tempQuery = this.getListQuery();

      $api
        .get("/v1/dashboard/stores" + tempQuery)
        .then((response) => {
          $excel.export(response.data, fields, "stores", headers);
        })
        .catch((e) => {
          alert(`Error: ${e}`);
        })
        .finally(() => {
          this.storeFileLoading = false;
        });
    },
    getListQuery() {
      const payload = {
        distributor_id: this.distributor_id,
        subdistributor_id: this.subdistributor_id,
        chain_id: this.chain_id,
        _start: this.dateRange ? this.dateRange.start : null,
        _end: this.dateRange ? this.dateRange.end : null,
        orderBy: this.orderBy? this.orderBy : null,
        isOrderByDesc: this.orderBy ? this.isOrderByDesc : null,
        searchKey: this.query ? this.query : null,
      };

      let tempQuery = "?";
      for (const key in payload) {
        if (payload[key] !== null && payload[key] !== undefined) {
          tempQuery += `&${key}=${payload[key]}`;
        }
      }

      return tempQuery;
    },
  },
};
</script>

<style scoped>
a {
  color: #000;
}
</style>
